import type { PageRequest } from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import type { Filter } from '../../../model/index.tsx';
import get from '../../../rest/filters/get/index.tsx';
import type { Response as RestResponse } from '../../../rest/filters/get/types.tsx';
import { transformFilters } from './transformers.tsx';
import type { Response as ResponseType } from './types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Response = ResponseType;

const getFilters = async (
	request: PageRequest,
	filter: Filter,
	isAdmin: boolean,
): Promise<Response> => {
	const restResponse: RestResponse = await get(request, filter, isAdmin);
	return transformFilters(restResponse.values, restResponse.total);
};

export default getFilters;
